import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-top",
  "use": "icon-top-usage",
  "viewBox": "0 0 200 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 200 200\" id=\"icon-top\">\n<path d=\"M185.8,76.8L99.7,0L13.5,76.8v32.9l73-65.1V200h23V41.7l76.3,68.1V76.8z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol